import backgroundImage from "../assets/BoxingRing.webp";
import startScreenImage from "../assets/start.png";

export default function Background({
  blur,
  isStartScreen,
}: {
  blur?: boolean;
  isStartScreen?: boolean;
}) {
  return (
    <div
      style={{
        backgroundImage: `url(${
          isStartScreen ? startScreenImage : backgroundImage
        })`,
      }}
      className={`bg ${blur ? "blur" : ""}`}
    />
  );
}
